const SET_SEEDS_WORKSPACE_ID = 'scratch-gui/seeds-workspace/SET_WORKSPACE_ID';
const SET_SEEDS_READ_ONLY = 'scratch-gui/seeds-workspace/SET_READ_ONLY';
const SET_AUTO_SAVE_STATUS = 'scratch-gui/seeds-workspace/SET_AUTO_SAVE_STATUS';

const initialState = {
    workspaceId: null,
    isReadOnly: false,
    autoSaveStatus: 'idle' // 'idle' | 'saving' | 'saved' | 'error'
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_SEEDS_WORKSPACE_ID:
        return {
            ...state,
            workspaceId: action.workspaceId
        };
    case SET_SEEDS_READ_ONLY:
        return {
            ...state,
            isReadOnly: action.isReadOnly
        };
    case SET_AUTO_SAVE_STATUS:
        return {
            ...state,
            autoSaveStatus: action.status
        };
    default:
        return state;
    }
};

const setSeedsWorkspaceId = workspaceId => ({
    type: SET_SEEDS_WORKSPACE_ID,
    workspaceId
});

const setSeedsReadOnly = isReadOnly => ({
    type: SET_SEEDS_READ_ONLY,
    isReadOnly
});

const setAutoSaveStatus = status => ({
    type: SET_AUTO_SAVE_STATUS,
    status
});

export {
    reducer as default,
    initialState as seedsWorkspaceInitialState,
    setSeedsWorkspaceId,
    setSeedsReadOnly,
    setAutoSaveStatus
};
